/**
 * A class to return the result of validating a verify email request token
 */
export class ValidateVerifyEmailTokenResponse {
  /** Boolean indicating whether account is already verified */
  public alreadyVerified: boolean;
  
  /** Boolean indicating whether the token is valid */
  public validToken: boolean;

  /** The password reset token */
  public token: string;

  /** The ID of the user requesting the password reset */
  public userId: string;

  /** The message returned to the user */
  public message: string;
}
